import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router} from '@angular/router';
import { JwtService } from '../jwt.service';
import { environment } from '../../environments/environment';
import { UserAuditV2Service } from '../reports/user-audit-updated/user-audit-v2.service';
import moment from 'moment';

/** build version */
const version = environment.version;

/** build time */
const build_time = environment.build_time;

/** Component decorator */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, OnDestroy {

  /** Pattern for EMail check  */
  mailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';

  /** Formgroup for authorization  */
  loginForm: FormGroup;

  /**  FormControl for Login as Email */
  fcLogin = new FormControl('', [Validators.required]);
  /** FormControl for Password  */
  fcPassword = new FormControl('', Validators.required);

  fcBillingId = new FormControl('',
   [Validators.required, Validators.minLength(36),Validators.maxLength(36)]);

  fcRememberMe = new FormControl(false);

  /** Show message when authorization was unsuccessful */
  showAuthErrorMessage: boolean;

  passwordVisibility: boolean;

  loginAttempts: any[] = [];

  /** Constructor of class LoginComponent  */
  constructor(alForm: FormBuilder, private router: Router, private auth: JwtService,
    private userAuditV2Service: UserAuditV2Service
    ) {

    /** Attaching FormControls to FormGroup  */
    this.loginForm = alForm.group({
      fcLogin: this.fcLogin,
      fcPassword: this.fcPassword,
      fcBillingId: this.fcBillingId,
      fcRememberMe: this.fcRememberMe
    });

    /** We don't show error message on default */
    this.showAuthErrorMessage = false;

  }

  getVersion() {
    return version;
  }

  clearForm() {
    this.fcLogin.patchValue(null);
    this.fcPassword.patchValue(null);
    this.fcBillingId.patchValue(null);
  }

  getBuiltTime() {
    return build_time;
  }

  forceReload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['']);
    // location.reload();
  }

  forceReload2() {
    location.reload();
  }

  /** Actions that would be executed on initialization of component */
  ngOnInit() {
    this.passwordVisibility = false;
    this.loadRememberMeFromStorage();

/*     this.userAuditV2Service.readConfig().toPromise().then((config: any) => {
      console.log(config);
      this.userAuditV2Service.setBackendUrl(config.backend_url);
    }).catch(err => {
      console.log('localhost');
      this.userAuditV2Service.setBackendUrl('http://six5-portal-svcs-dev.traefik.aws.submitmsg.com');
    }); */
  }

  /** check login and password. if succeed show EnterPin field */
  onSubmit(e) {

    this.userAuditV2Service.getIPCloudfare();
    if (this.fcLogin.value.indexOf('=') > -1) {
      return;
    }
    if (this.fcLogin.valid && this.fcPassword.valid) {

      this.loginAttempts.push({
        login: this.fcLogin.value,
        dt: moment.utc().format('YYYY-MM-DD hh:mm:ss')
      });

      this.auth.login(e.fcLogin, e.fcPassword, this.fcBillingId.value).toPromise().then(() => {
        this.showAuthErrorMessage = false;

        if (this.auth.loggedIn) {
          const ap = {
            comment: 'successful login attempt',
            attemps: this.loginAttempts
          };
          this.userAuditV2Service.createAuditRecord('Login', 'insert', JSON.stringify(ap));

          this.showAuthErrorMessage = false;
          /* let verTwo                = {}; */

/*           localStorage.removeItem('loggedInWithVer');
          if (this.app.userVer !== undefined && this.app.userVer === 2 ) {
            localStorage.setItem('loggedInWithVer', '2');
            verTwo = {ver: 2};
          } else {
            localStorage.setItem('loggedInWithVer', '1');
          } */

          this.router.navigate(['/panel']/* , { queryParams: verTwo} */);

          this.saveRememberMeToStorage();
        } else {

          // console.log('access denied');
          this.showAuthErrorMessage = true;
          /*           const ap = {
                      comment: 'unsuccessful login attempt'
                    };
                    this.userAuditV2Service.createAuditRecord('Login', 'insert', JSON.stringify(ap)); */
        }
      },
      error => {
        this.showAuthErrorMessage = true;
        // this.logger.error(error);
      }).catch(err => {
        this.showAuthErrorMessage = true;
      });
    }
  }

  showPass(mode: boolean) {
    this.passwordVisibility = mode;
  }

  getFieldType() {
    if (this.passwordVisibility === false) {
      return 'password';
    } else {
      return 'text';
    }
  }

  saveRememberMeToStorage() {
    localStorage.setItem('remember_me', this.fcRememberMe.value);
    localStorage.setItem('user_login', this.fcLogin.value);
  }

  loadRememberMeFromStorage() {
    if (localStorage.getItem('remember_me') === 'true') {
      this.fcLogin.patchValue(localStorage.getItem('user_login'));
      this.fcRememberMe.patchValue(true);
    } else {
      this.fcRememberMe.patchValue(false);
    }
  }

  /** destroy subscriptions in the end of component lifecycle */
  ngOnDestroy() {

  }

}

